import { Link, Element } from "react-scroll";
import { ReactComponent as Logo } from './assets/logoLoyalty.svg';
import { FaFacebook, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import useModal from "./hooks/useModal";
import Modal from "./components/Modal";
import { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import Inicio from "./views/Inicio";
import Quienes from "./views/Quienes";
import Services from "./views/Services";
import Publicidad from "./views/Publicidad";
import Contacto from "./views/Contacto";
import Testimonio from "./views/Testimonio";
import Opinion from "./views/Opinion";
import MANUAL from "./assets/manual.pdf";

const Header = () => {
  const activo = "underline decoration-red-500 decoration-2 underline-offset-4";
  const { open, close, isOpen } = useModal();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const navItems = (
    <>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="quienes" smooth={true} duration={500}>Quienes somos</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="servicios" smooth={true} duration={500}>Servicios</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="publicidad_streaming" smooth={true} duration={500}>Publicidad en streaming</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="contacto" smooth={true} duration={500}>Contacto</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="testimonio" smooth={true} duration={500}>Testimonio</Link>
      <button onClick={() => { open(); closeMenu(); }} className="hover:underline decoration-yellow-400 decoration-2 underline-offset-4">
        Manual org. y de procedimientos
      </button>
    </>
  );

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white shadow px-4 py-3 flex justify-between items-center">
      <Logo className="w-auto h-12" />

      <nav className="hidden md:flex gap-6 text-sm font-medium">
        {navItems}
      </nav>

      <div className="md:hidden">
        <button onClick={toggleMenu} aria-label="Toggle Menu">
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </button>
      </div>

      {menuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col items-start gap-4 p-4 text-sm font-medium z-40">
          {navItems}
        </div>
      )}

      {isOpen && (
        <Modal title="Manual organizacional" onClose={close}>
          <iframe src={MANUAL} className="w-full h-[65vh]" title="Manual org. y de procedimientos" />
        </Modal>
      )}
    </header>
  );
};

const Footer = () => (
    <footer className="h-fit w-full grid grid-cols-1 md:grid-cols-3 p-4 bg-gray-200 shadow text-black">
      <div className="flex flex-col justify-center items-start gap-2">
        <Logo className="w-auto h-16" />
      </div>
      <div>
        (52) 22 24 71 32 55
        <br/>
        loyalty.1512@gmail.com
        <br/>
        Dirección:
        Calle 47 Poniente,
        <br/>
        Col. Prados agua azul.
        <br/>
        C.P. 72430  Puebla, Pue.
      </div>
      <div className="flex flex-col justify-end items-center text-red-600 gap-2">
          <a href="https://www.instagram.com/incomeloyalty/" className="cursor-pointer" target="_blank" rel="noopener noreferrer">
            <FaInstagram size={27} />
          </a>
          <a href="https://www.facebook.com/people/Income-Services-Loyalty-SC/100064164126985/#" className="cursor-pointer" target="_blank" rel="noopener noreferrer">
            <FaFacebook size={27} />
          </a>
          <a href="https://api.whatsapp.com/send/?phone=522224713255&text&type=phone_number&app_absent=0" className="cursor-pointer" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp size={27} />
          </a>
          <a href="https://www.linkedin.com/in/income-services-loyalty-33209a202/" className="cursor-pointer" target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn size={27} />
          </a>
      </div>
    </footer>
);

function App() {
  return (
    <div>
      <Header/>
      <Inicio/>
      <Element name="quienes"> <Quienes/> </Element>
      <Element name="servicios"> <Services/> </Element>
      <Element name="publicidad_streaming"> <Publicidad/> </Element>
      <Element name="contacto"> <Contacto/> </Element>
      <Element name="testimonio">  <Testimonio/> </Element>
      <Opinion/>
      <Footer/>
    </div>
  );
}

export default App;
